import * as React from 'react';
import * as noteBlue from '../../../lotties/daily_lesson/note_blue.json';
import * as noteGreen from '../../../lotties/daily_lesson/note_green.json';
import * as notePink from '../../../lotties/daily_lesson/note_pink.json';
import * as noteYellow from '../../../lotties/daily_lesson/note_yellow.json';
import { DailyLessonLottieIcon } from './daily_lesson_lottie_icon';
const ANIMATION_BY_COLOR = {
    green: noteGreen,
    pink: notePink,
    yellow: noteYellow,
    blue: noteBlue,
};
export const DailyLessonNoteLottieIcon = ({ volumeColor, classObject }) => {
    return React.createElement(DailyLessonLottieIcon, { animationData: ANIMATION_BY_COLOR[volumeColor], classObject: classObject });
};
